import React from 'react';
import { Spinner } from 'react-bootstrap';
import AssignmentSummary from './assignment-summary';
import { sortByLesson } from '../utils';
import { SelectedAssignment } from '../types';

interface AssignmentSummaryPanelProps {
  assignments: SelectedAssignment[];
  loading: boolean;
}

const AssignmentSummaryPanel = ({ assignments, loading }: AssignmentSummaryPanelProps) => {
  if (assignments.length === 0) return null;
  if (loading) {
    return (
      <Spinner animation="border" role="status">
        <span className="sr-only">Loading...</span>
      </Spinner>
    );
  }
  return (
    <AssignmentSummary
      assignmentInfo={sortByLesson(assignments)}
    />
  );
};

export default AssignmentSummaryPanel;
